export default "__VITE_ASSET__DJIHBOir__"